import { NgModule } from '@angular/core';
import { FileUploadComponent } from './file-upload.component';
import { NgClass, NgIf } from '@angular/common';
import { FuseAlertModule } from '@fuse/components/alert';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


@NgModule({
  imports: [
    NgClass,
    NgIf,
    FuseAlertModule,
    MatProgressBar,
    MatProgressSpinner,
  ],
  exports: [FileUploadComponent],
  declarations: [FileUploadComponent],
  providers: [],
})
export class FileUploadModule { }
